import React, { useState } from "react";
import { DownOutlined } from "@ant-design/icons";
import { Button, Dropdown, Select, Tag } from "antd";
import { useDispatch, useSelector } from "react-redux";

import * as com from "../../Common";
import * as act from "../../Store/actions";
import { checkAccess } from "../../Auth";
import { UR_Owner } from "../../State";
import "./common.css";

interface CurrentStageProps {
  currentStage: string;
  loanID: string;
  boxClassName?: string;
  wrapClassName?: string;
  onChange?: Function;
  DispatchFn?: Function;
  isDispatch?: Boolean;
  value?:string;
  colNum?:number;
}

const CurrentStage = ({ currentStage, colNum=3,loanID, boxClassName, wrapClassName,value, onChange=()=>{}, isDispatch=true, DispatchFn=act.UpdateApplicationAttribute }: CurrentStageProps) => {
  const dispatch = useDispatch();
  const [oldStatus, setOldStatus] = useState(currentStage);
  const updateApplicationAttribute = (t, verb) => {
    dispatch(DispatchFn(t, verb));
  };
  const handleCurrentStageChange = (loanID, newCurrentStage) => {
    let token = sessionStorage.getItem("ZeitroA");
    let body = {
      LoanID: loanID,
      Key: "currentStage",
      Value: newCurrentStage,
      IsAdmin: checkAccess([UR_Owner]) ? true : false,
    };
    fetch("/los/updatepipeline", {
      method: "POST",
      body: JSON.stringify(body),
      headers: {
        Authorization: "Bearer " + token,
        Cache: "no-cache",
      },
    })
      .then((response) => {
        if (response.status !== 200) {
          console.log(
            "Looks like there was a problem. Status Code: " + response.status
          );
          // this.setState({ showErrorModal: true})
          return;
        }
        isDispatch && updateApplicationAttribute(newCurrentStage, "currentStage");
        onChange(newCurrentStage)
        setOldStatus(newCurrentStage)
        //   handleStatus(loanID, newStatus)
      })
      .catch(function (err) {
        console.log("Fetch Error :-S", err);
      });
  };
  const items = Object.entries(com.CurrentStage).map(([key, _]) => {
    return {
      value: key,
      key: key,
      label: <div>{key}</div>,
    };
  });
  return (
    <div className={['summaryLoansStageContainer',`col-${colNum}`,wrapClassName].join(' ')}>
      <div className={['loansStage', boxClassName].join(' ')}>
        <Select
          value={currentStage}
          options={items}
          onChange={(value) => {
            if(oldStatus===value) return;
            handleCurrentStageChange(loanID, value);
          }}
          suffixIcon={
            <img src="/images/stepper-menu-arrow-down.svg" alt="down-arrow" />
          }
        />
      </div>
    </div>
  );
};

export default CurrentStage;
